import styled from 'styled-components'

const EventsContainer = styled.section`
  padding-bottom: 36px;

  @media screen and (min-width: 600px) {
    padding: 0 0 100px;
  }

  .fc {
    background-color: #f7f7f7;
    padding: 21px 20px;

    @media screen and (min-width: 500px) {
      padding: 54px 32px;
    }

    &-toolbar.fc-header-toolbar {
      padding: 0 9%;
      margin-bottom: 18px;

      @media screen and (min-width: 500px) {
        margin-bottom: 60px;
      }

      @media screen and (min-width: 600px) {
        padding: 0 18%;
      }

      @media screen and (min-width: 960px) {
        padding: 0 9%;
      }

      @media screen and (min-width: 1200px) {
        padding: 0 18%;
      }

      .fc-toolbar-title {
        font-family: 'freight-sans-condensed-pro', sans-serif;
        font-size: 22px;
        font-size: 1.375rem;
        font-weight: 700;
        color: #114b89;

        @media screen and (min-width: 500px) {
          font-size: 34px;
          font-size: 2.125rem;
        }
      }
    }

    &-next-button,
    &-prev-button {
      width: 40px;
      height: 40px;
      padding: 0 !important;
      min-height: 0;
      min-width: 0;
      background: none !important;
      border-radius: 0 !important;
      border: 0 !important;
      transition: background-color 0.21s ease-out, border 0.21s ease-out;

      &:hover,
      &:focus {
        background: none;
        border: 0;
        background-color: #ee682f;
        box-shadow: none;
      }

      .fc-icon {
        width: 18px;
        height: 18px;
        margin: 0;
        position: relative;

        @media screen and (min-width: 500px) {
          width: 24px;
          height: 24px;
        }

        &::before,
        &::after {
          content: '';
          background-color: black;
          position: absolute;
        }

        &::before {
          width: 18px;
          height: 3px;
          bottom: 0;
          left: 0;

          @media screen and (min-width: 500px) {
            width: 24px;
            height: 4px;
          }
        }

        &::after {
          width: 3px;
          height: 18px;
          top: 0;

          @media screen and (min-width: 500px) {
            width: 4px;
            height: 24px;
          }
        }
      }
    }

    &-prev-button {
      padding: 1px 0 0 9px;

      .fc-icon {
        transform: rotate(45deg);

        &::after {
          left: 0;
        }
      }
    }

    &-next-button {
      padding: 1px 9px 0 0;

      .fc-icon {
        transform: rotate(-45deg);

        &::after {
          right: 0;
        }
      }
    }

    .fc-col-header {
      position: relative;
      margin-bottom: 28px;

      &::after {
        content: '';
        width: 96%;
        height: 2px;
        background-color: #d8d8d8;
        position: absolute;
        bottom: 0;
        left: 2%;
      }
    }

    &-scrollgrid {
      border: 0;
    }

    td,
    th {
      background-color: #f7f7f7;
      border: 0;
    }

    .fc-col-header-cell-cushion {
      font-size: 21px;
      font-size: 1.3125rem;
      font-weight: 700;
      color: #114b89;
      padding-bottom: 8px;

      @media screen and (min-width: 600px) {
        font-size: 38px;
        font-size: 2.375rem;
        padding-bottom: 14px;
      }

      &:hover,
      &:focus {
        text-decoration: none;
      }
    }

    .fc-day-today {
      background: none !important;
    }

    .fc-daygrid-day-frame {
      position: relative;

      &::before {
        content: '';
        display: block;
        padding-top: 100%;
      }

      .fc-daygrid-day-top {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;

        .fc-daygrid-day-number {
          width: 75%;
          height: 75%;
          text-align: center;
          font-weight: 400;
          font-size: 22px;
          font-size: 1.375rem;
          color: black;
          line-height: 0.7;
          position: relative;
          display: flex;
          justify-content: center;
          align-items: center;
          padding-bottom: 8px;

          @media screen and (min-width: 600px) {
            width: 64%;
            height: 64%;
            font-size: 38px;
            font-size: 2.375rem;
            padding-bottom: 14px;
          }

          @media screen and (min-width: 960px) {
            width: 75%;
            height: 75%;
            font-size: 32px;
            font-size: 2rem;
          }

          @media screen and (min-width: 1200px) {
            width: 64%;
            height: 64%;
            padding-bottom: 8px;
            font-size: 38px;
            font-size: 2.375rem;
          }

          &.has-event,
          &.active {
            &::before {
              content: '';
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
              background-color: #ee682f;
              z-index: -1;
              transition: width 0.21s ease-out, height 0.21s ease-out,
                top 0.21s ease-out, left 0.21s ease-out;
            }
          }

          &.active {
            color: white;

            &::before {
              background-color: #114b89;
            }
          }

          &:hover,
          &:focus {
            text-decoration: none;

            &::before {
              width: 110%;
              height: 110%;
              top: -5%;
              left: -5%;
            }
          }
        }
      }
    }

    .fc-day-disabled {
      background: none;
    }

    .fc-daygrid-day-events {
      display: none;
    }
  }
`

export default EventsContainer
